define(function(require) {
    const Cells = Object.assign(
        {},
        // Constants
        require('./cells/DateCell').CONSTANTS,
        {
            STAT_ABBREVIATIONS: require('./cells/StatCell').ABBREVIATIONS,
            STAT_PRECISION_MODES: require('./cells/StatCell').PRECISION_MODES
        },
        // Cells
        {
            ActionCell: require('./cells/ActionCell'),
            Cell: require('./cells/Cell'),
            CurrencyCell: require('./cells/CurrencyCell'),
            DateCell: require('./cells/DateCell').DateCell,
            EnumCell: require('./cells/EnumCell'),
            ExpandCell: require('./cells/ExpandCell'),
            ExportOnlyCell: require('./cells/ExportOnlyCell'),
            IconCell: require('./cells/IconCell'),
            IdCell: require('./cells/IdCell'),
            LinkCell: require('./cells/LinkCell'),
            StatCell: require('./cells/StatCell').StatCell,
            TextCell: require('./cells/TextCell'),
            ViewCell: require('./cells/ViewCell')
        }
    );

    return Cells;
});
